module.exports = __webpack_public_path__ + "static/media/6286BB42-F1C0-4A3B-B534-C7D544B44064-removebg-preview.178b6b9e.png";